import React from 'react';
import { cn } from '../../lib/utils';

export const Input = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'w-full bg-transparent border-0 border-b border-moss/50 rounded-none px-0 py-3 text-charcoal placeholder:text-muted/60 focus:outline-none focus:border-pond transition-colors font-sans text-base',
      className
    )}
    {...props}
  />
));

export const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'w-full bg-transparent border-0 border-b border-moss/50 rounded-none px-0 py-3 text-charcoal placeholder:text-muted/60 focus:outline-none focus:border-pond transition-colors font-sans text-base resize-none',
      className
    )}
    {...props}
  />
));

export const Select = React.forwardRef(({ className, children, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      'w-full bg-transparent border-0 border-b border-moss/50 rounded-none px-0 py-3 text-charcoal focus:outline-none focus:border-pond transition-colors font-sans text-base appearance-none cursor-pointer',
      className
    )}
    {...props}
  >
    {children}
  </select>
));

export const Label = ({ children, htmlFor, className }) => (
  <label
    htmlFor={htmlFor}
    className={cn('overline text-muted block mb-1', className)}
  >
    {children}
  </label>
);
